import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const masterAttributesAPI = createApi({
    reducerPath: 'masterAttributesAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        searchMasterCustomAttributes: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.SEARCH_MASTER_CUSTOM_ATTRIBUTES}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        getMasterCustomAttributes: builder.mutation({
            query: (query) => ({
                url: `${API_ENDPOINTS.GET_MASTER_CUSTOM_ATTRIBUTES}?${query.toString()}`,
                method: 'POST',
            }),
        }),
        createMasterCustomAttribute: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_MASTER_CUSTOM_ATTRIBUTE,
                method: 'POST',
                data,
            }),
        }),
        updateMasterCustomAttribute: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.UPDATE_MASTER_CUSTOM_ATTRIBUTE,
                method: 'POST',
                data,
            }),
        }),
        deleteMasterCustomAttribute: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_MASTER_CUSTOM_ATTRIBUTE,
                method: 'POST',
                data,
            }),
        }),
        getAuditLogs: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.GET_AUDIT_LOGS,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useSearchMasterCustomAttributesMutation,
    useGetMasterCustomAttributesMutation,
    useCreateMasterCustomAttributeMutation,
    useUpdateMasterCustomAttributeMutation,
    useDeleteMasterCustomAttributeMutation,
    useGetAuditLogsMutation,
} = masterAttributesAPI;
